import { format, parseISO, subDays, addDays } from 'date-fns';

/**
 * Get the browser's IANA timezone.
 * @returns {string}
 */
export function getBrowserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

/**
 * Convert a Date or ISO string to a canonical YYYY-MM-DD day key.
 * @param {Date|string} value
 * @returns {string}
 */
export function toDayKey(value = new Date()) {
  const date = typeof value === 'string' ? parseISO(value) : value;
  return format(date, 'yyyy-MM-dd');
}

/**
 * Today's day key in local browser time.
 * @returns {string}
 */
export function todayDayKey() {
  return toDayKey(new Date());
}

/**
 * Shift a day key by a number of days.
 * @param {string} dayKey
 * @param {number} offset
 * @returns {string}
 */
export function shiftDayKey(dayKey, offset) {
  return toDayKey(addDays(parseISO(dayKey), offset));
}

/**
 * Build a trailing day-key range ending on endDayKey.
 * @param {string} endDayKey
 * @param {number} days
 * @returns {string[]}
 */
export function trailingDayKeyRange(endDayKey, days) {
  const keys = [];
  for (let i = days - 1; i >= 0; i -= 1) {
    keys.push(format(subDays(parseISO(endDayKey), i), 'yyyy-MM-dd'));
  }
  return keys;
}
